import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InvoiceForm, {
  InvoiceFormFields,
} from '../../components/Invoice/InvoiceForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

export default function InvoicesNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: InvoiceFormFields) => {
    try {
      const response = await api.post(
        `organizations/${organization.id}/invoices`,
        data
      );
      const { id } = response.data;

      navigate(`/invoices/${id}/edit`);
    } catch (e: any) {
      if (e?.response?.data?.errors) {
        setFormErrors(e.response.data.errors);
      } else {
        throw e;
      }
    }
  };

  const [formFields, setFormFields] = useState<InvoiceFormFields>(
    {} as InvoiceFormFields
  );

  return (
    <InvoiceForm
      isLoading={1 + 1 === 1}
      title='Nova Ordem de Serviço'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
